"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reduxObservable = require("redux-observable");

var _createMonitoringEpic = _interopRequireDefault(require("./createMonitoringEpic"));

var _epics = _interopRequireDefault(require("settings-ui-sdk/epics"));

var _epics2 = _interopRequireDefault(require("settings-content-modals/EmailCreationModal/epics"));

var _epics3 = _interopRequireDefault(require("settings-content-modals/propertyDefaultsModals/epics"));

var _default = function _default(rootModule) {
  return (0, _reduxObservable.combineEpics)((0, _createMonitoringEpic.default)(rootModule), rootModule.rootEpic, _epics.default, _epics2.default, _epics3.default);
};

exports.default = _default;
module.exports = exports.default;